import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'userFilter',
})
export class UserFilterPipe implements PipeTransform {

    transform(items: any, filter: any, defaultFilter?: boolean, subKey?: any): any {
        if (!filter || !Array.isArray(items)) {
            return items;
        }
        subKey = subKey || 'user';

        if (filter && Array.isArray(items)) {
            let filterKeys = Object.keys(filter);

            if (defaultFilter) {

                return items.filter(item =>
                    filterKeys.reduce((x, keyName) =>
                        (x && (item[keyName] && item[keyName].toLowerCase().indexOf(filter[keyName].toLowerCase().trim()) != -1)) || filter[keyName] == "", true));
            }
            else {
                return items.filter(item => {
                    return filterKeys.some((keyName) => {
                        return (item[keyName] && item[keyName].toLowerCase().indexOf(filter[keyName].toLowerCase().trim()) != -1) ||
                            (item[subKey][keyName] && item[subKey][keyName].toLowerCase().indexOf(filter[keyName].toLowerCase().trim()) != -1) ||
                            filter[keyName] == "";
                    });
                });
            }
        }
    }
}